import { TaskFilters, TaskListItem } from "@myapp/contract";
import { useInfinitePaginated } from "../../../../shared/hooks/useInfinitePaginated";
import { taskKeys } from "../task.keys";
import { taskApi } from "../service";

/**
 * `options.enabled` exists for the search dropdowns, which mount closed: `EntitySearchSelect`
 * only enables its list once the user opens it, and without the passthrough every such field
 * would fetch a page of tasks on first paint. Mirrors `useUsersInfiniteQuery`.
 */
export function useTasksInfiniteQuery(
  filters: TaskFilters,
  options?: { enabled?: boolean },
) {
  return useInfinitePaginated<TaskFilters, TaskListItem>({
    queryKey: taskKeys.list(filters),
    params: filters,
    fetchFn: ({ page, ...rest }) =>
      taskApi.search({ ...rest, page }).then((response) => response.data),
    retry: false,
    enabled: options?.enabled,
  });
}
